/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PathologyStrictHttpResponse } from '../../pathology-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InsuranceGridResultDataModelSearchResultModel } from '../../models/insurance-grid-result-data-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface InsuranceSearchFormPost$Params {
      body?: SearchRequestModel
}

export function insuranceSearchFormPost(http: HttpClient, rootUrl: string, params?: InsuranceSearchFormPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<InsuranceGridResultDataModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, insuranceSearchFormPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PathologyStrictHttpResponse<InsuranceGridResultDataModelSearchResultModel>;
    })
  );
}

insuranceSearchFormPost.PATH = '/Insurance/SearchForm';
